import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import AdminRoute from "../components/AdminRoute";
import Account from "../pages/Account";
import AdminAnalytics from "../pages/AdminAnalytics";
import AdminDashboard from "../pages/AdminDashboard";
import AdminLogs from "../pages/AdminLog";
import AdminPanel from "../pages/AdminPanel";
import AdminPOS from "../pages/AdminPOS";
import AdminSalesReport from "../pages/AdminSalesReport";
import AllBrands from "../pages/AllBrands";
import AllCategories from "../pages/AllCategories";
import AllCoupons from "../pages/AllCoupons";
import AllOrder from "../pages/AllOrder";
import AllProducts from "../pages/AllProducts";
import AllReviews from "../pages/AllReviews";
import AllUsers from "../pages/AllUsers";
import Cancel from "../pages/Cancel";
import Cart from "../pages/Cart";
import CategoryProduct from "../pages/CategoryProduct";
import ForgotPassword from "../pages/ForgotPassword";
import Home from "../pages/Home";
import HotSale from "../pages/HotSale";
import Login from "../pages/Login";
import OrderPage from "../pages/OrderPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import ProductDetails from "../pages/ProductDetails";
import RefundHistory from "../pages/RefundHistory";
import ResetPassword from "../pages/ResetPassword";
import ReturnPolicy from "../pages/ReturnPolicy";
import SearchProduct from "../pages/SearchProduct";
import SignUp from "../pages/SignUp";
import Success from "../pages/Success";
import TermsOfService from "../pages/TermsOfService";
import UpdatePassword from "../pages/UpdatePassword";
import Wishlist from "../pages/Wishlist";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "sign-up",
        element: <SignUp />,
      },
      {
        path: "update-password",
        element: <UpdatePassword />,
      },
      {
        path: "reset-password",
        element: <ResetPassword />,
      },
      {
        path: "product-category",
        element: <CategoryProduct />,
      },
      {
        path: "product/:id",
        element: <ProductDetails />,
      },
      {
        path: "cart",
        element: <Cart />,
      },
      {
        path: "wishlist",
        element: <Wishlist />,
      },
      {
        path: "refund-history",
        element: <RefundHistory />,
      },
      {
        path: "success",
        element: <Success />,
      },
      {
        path: "cancel",
        element: <Cancel />,
      },
      {
        path: "search",
        element: <SearchProduct />,
      },
      {
        path: "hot-sale",
        element: <HotSale />,
      },
      {
        path: "order",
        element: <OrderPage />,
      },
      {
        path: "account",
        element: <Account />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "terms-of-service",
        element: <TermsOfService />,
      },
      {
        path: "return-policy",
        element: <ReturnPolicy />,
      },
      {
        path: "admin-panel",
        element: (
          <AdminRoute>
            <AdminPanel />
          </AdminRoute>
        ),
        children: [
          {
            path: "dashboard",
            element: (
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            ),
          },
          {
            path: "analytics",
            element: (
              <AdminRoute>
                <AdminAnalytics />
              </AdminRoute>
            ),
          },
          {
            path: "all-users",
            element: (
              <AdminRoute>
                <AllUsers />
              </AdminRoute>
            ),
          },
          {
            path: "all-products",
            element: (
              <AdminRoute>
                <AllProducts />
              </AdminRoute>
            ),
          },
          {
            path: "all-orders",
            element: (
              <AdminRoute>
                <AllOrder />
              </AdminRoute>
            ),
          },
          {
            path: "category",
            element: (
              <AdminRoute>
                <AllCategories />
              </AdminRoute>
            ),
          },
          {
            path: "brand",
            element: (
              <AdminRoute>
                <AllBrands />
              </AdminRoute>
            ),
          },
          {
            path: "pos",
            element: (
              <AdminRoute>
                <AdminPOS />
              </AdminRoute>
            ),
          },
          {
            path: "logs",
            element: (
              <AdminRoute>
                <AdminLogs />
              </AdminRoute>
            ),
          },
          {
            path: "coupons",
            element: (
              <AdminRoute>
                <AllCoupons />
              </AdminRoute>
            ),
          },
          {
            path: "reviews",
            element: (
              <AdminRoute>
                <AllReviews />
              </AdminRoute>
            ),
          },
          {
            path: "reports",
            element: (
              <AdminRoute>
                <AdminSalesReport />
              </AdminRoute>
            ),
          },
        ],
      },
    ],
  },
]);

export default router;
